import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceCreateEvidenceFieldPayload } from 'api/actions/device-create-evidence-field/device-create-evidence-field-payload';
import { DeviceCreateEvidenceFieldPathParameters } from 'api/actions/device-create-evidence-field/device-create-evidence-field-path-parameters';
import { DeviceCreateEvidenceFieldResponse } from 'api/actions/device-create-evidence-field/device-create-evidence-field-response';

type DeviceCreateEvidenceFieldQueryParameters = Record<string, any>;

/**
 * The path of the DeviceCreateEvidenceField action.
 */
export const deviceCreateEvidenceFieldActionPath = new SweetPath<keyof DeviceCreateEvidenceFieldPathParameters>(
  '/api/device/evidence-fields/create',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceCreateEvidenceField actions.
 */
export default function createDeviceCreateEvidenceFieldAction(axios: AxiosInstance) {
  return function deviceCreateEvidenceFieldAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: DeviceCreateEvidenceFieldQueryParameters;
    payload: DeviceCreateEvidenceFieldPayload;
  }) {
    const path = deviceCreateEvidenceFieldActionPath.original;

    return axios.request<DeviceCreateEvidenceFieldResponse, DeviceCreateEvidenceFieldResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
